var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvioOFaded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.887,
    height: 57.398,
    viewBox: "0 0 58.887 57.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b,.c{fill:#353841;}.c{fill-rule:evenodd;}.d{filter:url(#c);}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 1.668,
    width: 58.887,
    height: 55.73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 11.798,
    y: 0,
    width: 35.271,
    height: 35.271,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-401.364 -405.327)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, 401.36, 405.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M907.6,256.464v.042a2.978,2.978,0,0,0,.957,2.152,8.933,8.933,0,0,1,2.692,6.516v.1c0,4.669-3.181,8.569-8.21,8.569a8.35,8.35,0,0,1-8.26-8.671v-.1a8.847,8.847,0,0,1,2.688-6.559,2.905,2.905,0,0,0,.96-2.124h0a2.835,2.835,0,0,0-4.619-2.2,14.023,14.023,0,0,0-5.237,10.985v.1a14.011,14.011,0,0,0,14.367,14.007,14.164,14.164,0,0,0,14.52-14.11v-.1a13.876,13.876,0,0,0-5.139-10.87A2.9,2.9,0,0,0,907.6,256.464Z",
    transform: "translate(-873.57 -236.89)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 401.36, 405.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1016.17,238.144a2.636,2.636,0,1,1,2.636,2.635,2.635,2.635,0,0,1-2.636-2.635",
    transform: "translate(-989.37 -220.51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvioOFaded);
export default __webpack_public_path__ + "static/media/evio_o_faded.cc6ded51e6435c2282242e50e67104d0.svg";
export { ForwardRef as ReactComponent };